import { Spin } from 'antd';
import styled, { css } from 'styled-components';

type BackgroundProps = {
  $isFullScreen?: boolean;
};

export const Background = styled.div<BackgroundProps>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ $isFullScreen }) =>
    $isFullScreen
      ? css`
          height: calc(100vh - 80px);
        `
      : css`
          margin-top: 20vh;
        `}
`;

export const Spinner = styled(Spin)`
  .ant-spin-text {
    font-size: 1.5em;
  }
`;
